"use strict";
/**
 * @file Created on 03/03/2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ResourceLockType_1 = require("../../resource-lock/enums/ResourceLockType");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * @author Tomas Leity
 */


var ForecastSimulationLockDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationLockDTO, _DomainObject_1$Domai);

  /**
   * @param {string} promotionId
   * @param {string} resourceId
   * @param {ResourceLockType} resourceLockType
   * @param {UserInfo} assignee
   */
  function ForecastSimulationLockDTO(promotionId, resourceId, resourceLockType, assignee) {
    var _this;

    _classCallCheck(this, ForecastSimulationLockDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationLockDTO).call(this));
    _this.promotionId = promotionId;
    _this.resourceId = resourceId;
    _this.resourceLockType = resourceLockType;
    _this.assignee = assignee;
    return _this;
  }

  return ForecastSimulationLockDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationLockDTO = ForecastSimulationLockDTO;

ForecastSimulationLockDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastSimulationLockDTO.name);
  return {
    promotionId: builder.str('promotionId'),
    resourceId: builder.str('resourceId'),
    resourceLockType: builder.senum('resourceLockType', ResourceLockType_1.ResourceLockType, 'enums/ResourceLockType'),
    assignee: builder.obj('assignee', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })
  };
}();